export const UTILITY_GET_STATES = 'UTILITY_GET_STATES';
export const UTILITY_SET_STATES = 'UTILITY_SET_STATES';
export const UTILITY_GET_DASHBOARD_COUNTS = 'UTILITY_GET_DASHBOARD_COUNTS';
export const UTILITY_INIT_DASHBOARD_COUNTS = 'UTILITY_INIT_DASHBOARD_COUNTS';
export const UTILITY_SET_DASHBOARD_STATE = 'UTILITY_SET_DASHBOARD_STATE';
export const UTILITY_SET_DASHBOARD_COUNTS = 'UTILITY_SET_DASHBOARD_COUNTS';
export const UTILITY_NOTIFY_ERROR = 'UTILITY_NOTIFY_ERROR';
